import React from 'react'
import { SxProps } from '@mui/material/styles'
import { P } from '@mxenabled/mxui'
import { TypographyProps } from '@mui/material/Typography'
import { formatCurrency } from '../../core/utils/NumberFormatting'

interface CurrencyTextProps extends TypographyProps {
  isIncome?: boolean
  amount: number | string
  bold?: boolean
  color?: string
  formatString?: string
  sx?: SxProps
  symbol?: string
  variant?: TypographyProps['variant']
}

export const CurrencyText: React.FC<CurrencyTextProps> = ({
  isIncome = false,
  amount = 0,
  bold,
  color,
  formatString,
  sx,
  symbol,
  variant,
  ...rest
}) => {
  const textColor = () => {
    if (color) {
      return color
    } else {
      return isIncome ? 'success.main' : 'text.primary'
    }
  }

  return (
    <P bold={bold} color={textColor()} sx={sx} variant={variant} {...rest}>
      {symbol}
      {formatCurrency(Number(amount), formatString ?? '0,0.00')}
    </P>
  )
}
